import Button from '@sdk/components/ui/buttons/Button';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { FooterRegularButtonWrapper } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';

type Props = {
  onEdit: VoidFunction;
};
const EditTimesheetFooterButton = ({ onEdit }: Props) => (
  <FooterRegularButtonWrapper mLeft={10}>
    <Button onClick={onEdit} buttonType={ButtonType.primary}>
      <Text14 themeColor={ThemeColorType.bodyBg}>{gettext('Edit timesheet')}</Text14>
    </Button>
  </FooterRegularButtonWrapper>
);

export default EditTimesheetFooterButton;
